export const smediasState = {
  smediasFormStatus: false,
  smediasIsEdit: false,
  smediasSelectedForEdit: null,
};